export type FaqItem = {
	title: string;
	paragraphs: readonly string[];
};

export const POOLS_FAQ_DESCRIPTION =
	"Here are some common questions we get about exploring & analyzing liquidity pools. Can't find the answer you're looking for? Email us at support@unilytics.app.";

export const POOLS_FAQS: FaqItem[] = [
	{
		title: "How can I estimate how much I'll earn from a liquidity pool?",
		paragraphs: [
			"Our APR data shows you the annualized returns the average liquidity provider is earning in each pool, based on the past day, 7 days, and 30 days of trade volume.",
			"You may over- or under-perform this average, based on TVL fluctuations, trade volume fluctuations, and the specific price range you choose.",
			"For a more fine-tuned earnings estimate, use the Analyze tab to choose a price range and enter a deposit amount.",
		],
	},
	{
		title: "How often is Unilytics data updated?",
		paragraphs: [
			"All of our liquidity pool data is updated hourly, except for Altcoin/Stablecoin and ETH/Altcoin pools – which are updated every 4 hours.",
		],
	},
	{
		title: "Unilytics TVL and APR data differs from what I see on Uniswap. Why?",
		paragraphs: [
			"When our data disagrees with Uniswap, it's typically due to minor discrepancies in how often data is refreshed. Through independent AI analysis, Unilytics typically provides more accurate, real-time representations of TVL and APR than Uniswap itself.",
		],
	},
	{
		title: "How can I learn more about providing liquidity?",
		paragraphs: [
			"We have various educational resources available. Email support@unilytics.app to learn more.",
		],
	},
];

export const PLANS_FAQ_DESCRIPTION =
	"Here are some common questions we get about plans and billing. Can't find the answer you're looking for? Email us at support@unilytics.app.";

export const PLANS_FAQS: FaqItem[] = [
	{
		title: "How does the Monthly Plan work?",
		paragraphs: [
			"Our Unilytics Pro Monthly Plan comes with a 7-day free trial. Once you start your free trial, you'll have 7 days to get the full Unilytics Pro experience.",
			"If you love it, you'll continue on at the regular rate of $97/month. You can cancel any time – before or after your free trial – inside your account.",
		],
	},
	{
		title: "How does the Yearly Plan work?",
		paragraphs: [
			"Our Unilytics Pro Yearly Plan gives you the option to forego your free trial, pre-pay for the year, and save $667 off the monthly rate.",
		],
	},
	{
		title: "Does the Yearly Plan renew automatically?",
		paragraphs: [
			"Yes, the Yearly Plan renews at $497/year. We will send you reminder emails 7 days and 2 days prior to renewal so you don't forget.",
			"You can cancel your Yearly Plan any time inside your account.",
		],
	},
	{
		title: "Can I change my plan later?",
		paragraphs: [
			"You can switch from a Monthly Plan to a Yearly Plan (or vice versa) at any time.",
			"However, the 57% discount on our Yearly Plan is for new users on this page only.",
		],
	},
	{
		title: "What is your cancellation policy?",
		paragraphs: [
			"You can cancel your Monthly Plan or Yearly Plan at any time. Cancellation is just two simple clicks inside your account.",
		],
	},
];
